<template>
  <div class="approval">
    <div v-if="approve_photo">
      <van-image
        :src="envs + approve_photo"
        width="92%"
        height="200px"
        fit="scale-down"
      />
    </div>
    <div class="PersonnelInformation">
      <div class="header">{{ stateMap[approvalData.state] }}</div>
      <div class="item">来访人：{{ visitor_name }}</div>
      <div class="item">手机号:{{ visitor_tel }}</div>
      <div class="item">来访人数：{{ user_count }}人</div>
      <div class="item">来访事由：{{ visitor_reason }}</div>
      <div class="item">来访时间：{{ visitor_in_time }}</div>
    </div>
    <div class="gap">
      <a
        class="approvalImage_a"
        :class="{ approvalImage: approve_photo }"
        :href="'tel:' + visitor_tel"
        v-if="visitor_tel"
      >
        <van-image
          src="https://client.12kcool.com/qingjia.png"
          width="30px"
          height="30px"
          fit="scale-down"
        />
      </a>
    </div>
    <van-steps
      v-if="approvalData.groups"
      direction="vertical"
      active-color="#1cab7d"
      :active="currentIndex"
    >
      <van-step v-for="(item, index) in approvalData.groups" :key="item.id">
        <template #active-icon>
          <div class="step-icon step-icon-ac"></div>
        </template>
        <template #finish-icon>
          <div class="step-icon step-icon-ac"></div>
        </template>
        <template #inactive-icon>
          <div class="step-icon"></div>
        </template>
        <h3 v-if="item.type === 'submit'">发起审批</h3>
        <h3 v-else-if="index <= currentIndex">{{ dicMap[item.state] }}</h3>
        <h3 v-else>待审批</h3>
        <div class="itemname" v-if="item.type === 'submit'">
          <div class="item-name">{{item.records[0].operator.user_name}}</div>
          <div class="item-date">{{ dayjs(item.records[0].time).format("MM-DD HH:mm") }}</div>
        </div>
        <div class="" v-else>
          <div class="label" v-if="item.total>1">{{ item.total }}人，{{ item.type !== 'or' ? '全部审批' : '任一人审批' }}</div>
          <template v-for="(items, i) in item.records" :key="i">
            <div  v-if="items.state !== 0">
              <div class="itemname">
                <div class="item-name">{{ items.operator.user_name }}（ {{items.state===1?'已同意':items.state===2?'已拒绝':''}}）</div>
                <div class="formatDates">{{ dayjs(items.time).format("MM-DD HH:mm") }}</div>
              </div>
              <div class="remark" v-if="items.opinion">{{ items.opinion }}</div>
            </div>
          </template>
									
          <div class="approvalList">
            <template v-for="(items, i) in item.records" :key="i">
            <div class="approvalItem" v-if="items.state === 0">
              <span>{{ items.operator.user_name }}</span>
              <!-- <text class="icon iconfont iconfont-X"></text> -->
              <span v-if="i != item.records.length - 1">、</span>
            </div>
            </template>
          </div>
        </div>
      </van-step>
      <!-- <van-step>
        <h3>{{ approve_status }}</h3>
        <p>{{ touser_name }}</p>
      </van-step> -->
    </van-steps>
    <div class="button" v-if="approvalData.current_users.includes(Number(approve_user_id))">
      <!-- <van-button
        color="linear-gradient(to right, #ff6034, #ee0a24)"
        size="normal"
        round
        style="display: none;"
        @click="setApprove()"
        >待定</van-button
      > -->
      <van-button
        color="linear-gradient(to right, #ff6034, #ee0a24)"
        size="normal"
        round
        @click="setApprove(1)"
        >拒绝</van-button
      >
      <van-button size="normal" color="#1cab7d" @click="setApprove(2)" round
        >同意</van-button
      >
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, onMounted, ref, watch, reactive } from "vue";
import { Image, Steps, Step, Button, Popup, Dialog } from "vant";
import Account from "@/api/account";
import dayjs from "dayjs";

export default defineComponent({
  name: "DetailvueApproval",
  props: {
    approveInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return { show: false };
  },
  components: {
    "van-image": Image,
    "van-step": Step,
    "van-steps": Steps,
    "van-button": Button,
    "van-popups": Popup,
  },
  setup(props, ctx) {
    const visitor_name = ref("");
    const user_count = ref("");
    const visitor_tel = ref("");
    const approve_photo = ref("");
    const visitor_reason = ref("");
    const touser_name = ref("");
    const visitor_in_time = ref("");
    const approve_status = ref("");
    const status = ref(0);
    const id = ref("");
    const approve_user_id = ref("");
    const approvalData = ref<any>({});
    const stateMap = ref<any>({
      InApproval: '待审批',
      ApprovalPassed: '审批通过',
      ApprovalAborted: '审批拒绝',
    });
    const currentIndex = ref(0);
    const dicMap = ref<any>({});
    const dicData = [
      {
        code_item_id: "0",
        code_item_name: "请假申请",
      },
      {
        code_item_id: "7",
        code_item_name: "审批中",
      },
      {
        code_item_id: "9",
        code_item_name: "请假录入",
      },
      {
        code_item_id: "8",
        code_item_name: "已撤销",
      },
      {
        code_item_id: "2",
        code_item_name: "审批拒绝",
      },
      {
        code_item_id: "3",
        code_item_name: "撤销申请",
      },
      {
        code_item_id: "4",
        code_item_name: "审批通过",
      },
      {
        code_item_id: "5",
        code_item_name: "审批拒绝",
      },
      {
        code_item_id: "6",
        code_item_name: "审批已阅",
      },
      {
        code_item_id: "10",
        code_item_name: "返校审批中",
      },
      {
        code_item_id: "11",
        code_item_name: "返校通过",
      },
      {
        code_item_id: "12",
        code_item_name: "返校拒绝",
      },
      {
        code_item_id: "1",
        code_item_name: "审批通过",
      },
    ];
    dicData.forEach((item) => {
      dicMap.value[item.code_item_id] = item.code_item_name;
    })
    //const envs = ref('https://res-mal.12kcool.com/')
    const envs = ref("https://res-k12.12kcool.com/");
    const setApprove = (status?: number) => {
      let approvalId = "";
      const params = {
        approve_user_id: approve_user_id.value,
      };
      if (!status) {
        approvalId = "-1";
      }
      Dialog.confirm({
        title: "提示",
        message: `确定要${status === 2 ? "同意" : "拒绝"}吗？`,
      })
        .then(async () => {
          // on confirm
          const [err, data] = await Account.setApprove(
            approvalId || id.value,
            status,
            params
          );
          ctx.emit('refresh');
          console.log(data);
        })
        .catch(() => {
          // on cancel
        });
    };
    const setid = async (ids: any) => {
      id.value = ids;
    };
    const setVisitorId = async (ids: any) => {
      approve_user_id.value = ids;
    };

    const getstatus = (statu: number) => {
      let val = "";
      if (statu === 0) {
        val = "待审批";
      } else if (statu === 1) {
        val = "审批拒绝";
      } else {
        val = "审批通过";
      }
      return val;
    };
    watch(
      () => props.approveInfo,
      (val) => {
        console.log("approveInfo", val);
        const data = val || {};
        approvalData.value = data.approve_data?.approval || {};
        if (approvalData.value.groups) {
					if (approvalData.value.state === 'InApproval') {
						const index = approvalData.value.groups.findIndex(
              (item: any) => item.id === approvalData.value.current_group
            );
            currentIndex.value = index === -1 ? 0 : index;
					} else {
						currentIndex.value = approvalData.value.groups?.length - 1 || 0
					}
        } else {
          currentIndex.value =  0
        }
        visitor_name.value = data.visitor_name;
        user_count.value = data.user_count;
        visitor_tel.value = data.visitor_tel;
        approve_photo.value = data.approve_photo;
        visitor_reason.value = data.visitor_info.visitor_reason;
        touser_name.value = data.visitor_info.touser_name;
        visitor_in_time.value = dayjs(data.visitor_in_time).format(
          "YYYY-MM-DD HH:mm"
        );
        approve_status.value = getstatus(data.visitor_info.approve_status);
        status.value = data.visitor_info.approve_status;
      },
      {
        deep: true,
        immediate: true,
      }
    );
    onMounted(async () => {
      // Notify('onMounteSSSd')
    });

    return {
      envs,
      visitor_name,
      user_count,
      visitor_tel,
      approve_photo,
      visitor_reason,
      touser_name,
      visitor_in_time,
      approve_status,
      status,
      setApprove,
      setid,
      setVisitorId,
      id,
      approve_user_id,
      approvalData,
      stateMap,
      currentIndex,
      dicMap,
      dayjs
    };
  },
  created() {
    console.log("query", this.$route.query);
    this.setid(this.$route.query.touser_id);
    this.setVisitorId(this.$route.query.approve_user_id);
  },
});
</script>
<style scoped lang="scss">
h3 {
  font-size: 16px;
}
.formatDates {
  font-size: 14px;
  color: #A4adb9;
  display: inline-block;
  line-height: normal;
}
.itemname {
  display: flex;
    justify-content: space-between;
    width: 95%;
}
.item-name {
  font-size: 14px;
  line-height: normal
}
.remark {
  height: 42px;
  line-height: 42px;
  background: #EEEEF3;
  padding-left: 12px;
  border-radius: 5px;
  font-size: 14px;
  color: #8C9197;
  margin-top: 6px;
}

.label {
  background-color: #e3fff2;
  padding: 3px 8px;
  color: #28b078;
  line-height: normal;
  font-size: 14px;
  border-radius:3px;
  display: inline-block;
  margin-top: 6px;
}
.approvalList {
  margin-top: 13px;
  display: flex;
  justify-content: left;
  flex-wrap: wrap;
  color: #999;
  .approvalItem {
    display: inline-block;
    position: relative;
    margin-bottom: 6upx;
    .icon {
      position: absolute;
      top: -6px;
      right: 5px;
      color: #ff201B;
      font-size: 30upx;
    }
  }
}
.van-steps{
  .van-step--vertical:not(:last-child)::after {
    border: none !important;
  }
  .van-step--vertical {
    padding: 2px 10px 5px 0 !important;
  }
  .step-icon {
    width: 10px;
    height: 10px;
    background-color: #C0C0C0;
    border-radius: 50%;
    box-shadow: 0 0 10px #C0C0C0;
  }
  .step-icon-ac {
    background-color: #1cab7d;
    box-shadow: 0 0 10px rgba(28, 171, 125, 0.9);
  }
}
.approval {
  margin-left: 3%;
  .van-step--finish {
    color: #969799;
  }
  .PersonnelInformation {
    padding: 5px 0;
    .header {
      font-size: 18px;
      color: #efa707;
    }
    .item {
      font-size: 14px;
      color: #666;
    }
  }
  .van-step--vertical {
    padding: 8px 10px 5px 0;
    line-height: 4px;
  }
  .button {
    display: flex;
    justify-content: space-around;
    margin-top: 30px;
    button {
      width: 30%;
    }
  }
  .gap {
    position: relative;
    width: 103%;
    height: 15px;
    background-color: #e8e7e7cc;
    left: -3%;
  }
  .approvalImage_a {
    position: relative;
    left: 150px;
    top: -66px;
  }

  .approvalImage {
    top: -266px;
  }
  .van-steps--vertical {
    padding: 0 0 0 20px;
  }
}
</style>
